export default __webpack_public_path__ + "static/media/profile-pics.d065260f.png";